/**
 * TSOG 商品ショーケース - Splide初期化
 */

class TsogProductShowcase {
  constructor() {
    this.init();
  }

  init() {
    // DOMContentLoadedまたはSplide読み込み完了を待つ
    if (typeof Splide !== 'undefined') {
      this.initializeSliders();
    } else {
      // Splideがまだ読み込まれていない場合は待機
      const checkSplide = setInterval(() => {
        if (typeof Splide !== 'undefined') {
          clearInterval(checkSplide);
          this.initializeSliders();
        }
      }, 100);

      // 10秒経っても読み込まれない場合はタイムアウト
      setTimeout(() => {
        clearInterval(checkSplide);
        console.warn('Splide library failed to load');
      }, 10000);
    }
  }

  initializeSliders() {
    // セクション設定を取得
    if (!window.tsogShowcaseSections || window.tsogShowcaseSections.length === 0) {
      return;
    }

    window.tsogShowcaseSections.forEach((config) => {
      this.initializeSlider(config);
    });

    // 初期化後にリセット
    window.tsogShowcaseSections = [];
  }

  initializeSlider(config) {
    const {
      sectionId,
      slidesPerView = 2,
      spaceBetween = 20,
      autoplay = false,
      autoplayDelay = 3000, // ミリ秒単位（Liquidテンプレートで秒→ミリ秒に変換済み）
      loop = true
    } = config;

    const sliderElement = document.querySelector(`.tsog-splide-${sectionId}`);

    if (!sliderElement) {
      console.warn(`Splide element not found for section ${sectionId}`);
      return;
    }

    // 既に初期化されている場合はスキップ
    if (sliderElement.splide) {
      return;
    }

    const splideConfig = {
      type: loop ? 'loop' : 'slide',
      perPage: slidesPerView,
      perMove: 1,
      gap: `${spaceBetween}px`,
      padding: 0,
      arrows: false,
      pagination: true,
      drag: true,
      keyboard: true,

      // 自動再生
      autoplay: autoplay,
      interval: autoplayDelay,
      pauseOnHover: true,
      pauseOnFocus: true,

      // レスポンシブブレークポイント
      breakpoints: {
        // モバイル
        640: {
          perPage: 2,
          gap: `${spaceBetween * 0.5}px`,
        },
        // タブレット
        990: {
          perPage: Math.min(slidesPerView, 1.5),
          gap: `${spaceBetween * 0.75}px`,
        },
        // デスクトップ小
        1200: {
          perPage: Math.min(slidesPerView, 2),
          gap: `${spaceBetween}px`,
        },
      },

      // アクセシビリティ
      i18n: {
        prev: '前のスライド',
        next: '次のスライド',
        first: '最初のスライドへ',
        last: '最後のスライドへ',
        slideX: 'スライド %s',
        pageX: 'ページ %s',
        play: '自動再生',
        pause: '一時停止',
      },

      // カスタムクラス
      classes: {
        arrows: 'splide__arrows',
        arrow: 'splide__arrow',
        prev: 'splide__arrow--prev',
        next: 'splide__arrow--next',
        pagination: 'splide__pagination',
        page: 'splide__pagination__page',
      },
    };

    // Splideインスタンスを作成
    try {
      const splide = new Splide(sliderElement, splideConfig);

      // イベントリスナー
      splide.on('moved', (newIndex) => {
        // スライド変更時の処理（アナリティクスなど）
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'slide_change', {
            event_category: 'Product Showcase',
            event_label: sectionId,
            value: newIndex
          });
        }
      });

      splide.mount();
    } catch (error) {
      console.error('Failed to initialize Splide:', error);
    }
  }
}

// Shopifyテーマエディターでのリロード対応
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    // セクションが読み込まれたら再初期化
    setTimeout(() => {
      new TsogProductShowcase();
    }, 100);
  });

  document.addEventListener('shopify:section:reorder', () => {
    // セクションの順序が変更されたら全体を再初期化
    setTimeout(() => {
      new TsogProductShowcase();
    }, 100);
  });
}

// 初期化実行
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new TsogProductShowcase();
  });
} else {
  new TsogProductShowcase();
}
